import React, { useState } from 'react';
import { Menu, X, Zap } from 'lucide-react';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const navLinks = [
    { label: 'Hjem', href: '#hero' },
    { label: 'Oppdag', href: '#oppdag' },
    { label: 'Funksjoner', href: '#funksjoner' },
    { label: 'Anmeldelser', href: '#anmeldelser' },
    { label: 'Vanlige spørsmål', href: '#faq' },
    { label: 'Kontakt', href: '#kontakt' },
  ];

  return (
    <header className="bg-dark/95 backdrop-blur-sm sticky top-0 z-50 border-b border-border-dark">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
              <Zap className="w-5 h-5 text-white" />
            </div>
            <span className="text-2xl font-bold text-white font-heading tracking-tight">
              Workout <span className="text-primary-light">ON</span>
            </span>
          </div>

          <nav className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-slate-300 hover:text-primary-light transition-colors duration-200 text-sm font-medium"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center space-x-4">
            <a
              href="/s"
              className="hidden md:inline-flex items-center bg-primary hover:bg-primary-dark text-white px-6 py-2 rounded-lg font-semibold text-sm transition-colors duration-200 shadow-lg shadow-primary/25"
            >
              Fortsett
            </a>
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="md:hidden text-slate-300 hover:text-white p-2"
            >
              {menuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="md:hidden border-t border-border-dark py-4">
            <nav className="flex flex-col space-y-3">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={() => setMenuOpen(false)}
                  className="text-slate-300 hover:text-primary-light transition-colors px-2 py-1 text-sm font-medium"
                >
                  {link.label}
                </a>
              ))}
              <a
                href="/s"
                className="bg-primary hover:bg-primary-dark text-white px-6 py-2 rounded-lg font-semibold text-sm text-center mt-2 transition-colors"
              >
                Fortsett
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
